/**
 * The session replay recorder captures the document URL into its own upload stream, which no
 * event-level redaction reaches. Public booking pages carry a meeting id in that URL and the custom
 * domain test page carries its link token, and both are used by people without a Blockit account,
 * so replay is not started there at all.
 */
const UNRECORDED_PATH_PREFIXES = ['/link/', '/custom-domain-test'];

export const shouldRecordSessionReplay = (pathname: string): boolean => {
  return !UNRECORDED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};
